import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import History from "./History/History";
import Content from "./Content/Content";

export default function Home() {
  const { stories } = useSelector((s) => s.home);
  const navigate = useNavigate();
  const hasRedirected = useRef(
    sessionStorage.getItem("shopRedirectHandled") === "true"
  );

  useEffect(() => {
    const { start_param: startParam } =
      window.Telegram?.WebApp?.initDataUnsafe || {};

    if (!hasRedirected.current && startParam === "unconfirmed-batches") {
      hasRedirected.current = true;
      sessionStorage.setItem("shopRedirectHandled", "true");
      navigate("/unconfirmed-batches", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <History stories={stories} />
      <Content />
    </>
  );
}
